import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import { curry, get, capitalize, lowerCase } from 'lodash';

import requestLineOptionsQuery from './requestLineOptionsQuery';
import { optionsByType, optionsTransformersByType } from './constants';

export const optionTypes = [
  'rimType',
  'axleType',
  'tirePosition',
  'tireCondition',
  'requestedAction',
];

const optionPropType = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }),
);

export const requestLineOptionsPropType = PropTypes.shape(
  optionTypes.reduce((acc, type) => ({ ...acc, [type]: optionPropType }), {}),
);

export const getScalarTitle = (type, name) =>
  get(optionsByType, `${type}.${name}`, capitalize(lowerCase(name)));

const mapScalarOptions = (options, type) =>
  options.map(({ name }) => ({ id: name, title: getScalarTitle(type, name) }));

const buildOptions = data =>
  optionTypes.reduce((acc, type) => {
    let options = get(data, `${type}.enumValues`, []);
    const transformer = optionsTransformersByType[type];

    if (transformer) options = transformer(options);

    return { ...acc, [type]: mapScalarOptions(options, type) };
  }, {});

export const buildQueryChild = curry(
  (WrappedComponent, componentProps, { data, loading }) => (
    <WrappedComponent
      {...componentProps}
      requestLineOptions={buildOptions(data)}
      isLoadingRequestLineOptions={loading}
    />
  ),
);

const withRequestLineOptions = WrappedComponent => componentProps => (
  <Query query={requestLineOptionsQuery}>
    {buildQueryChild(WrappedComponent, componentProps)}
  </Query>
);

export default withRequestLineOptions;



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/CaseRequestsPanelContext/withRequestLineOptions/index.js